import { useTranslation } from 'react-i18next'

export type SeasonStatus = 'archived' | 'active' | 'in-progress'

export interface AvailableSeason {
  season: string
  status: SeasonStatus
}
export interface SeasonCardProps {
  season: AvailableSeason
  onClick: () => void
}

export function SeasonCard({ season, onClick }: Readonly<SeasonCardProps>) {
  const { t } = useTranslation()
  const shortYear = season.season.slice(-2)
  const fullYear = 2000 + Number.parseInt(shortYear, 10)
  const typeLabel = season.season.startsWith('SS')
    ? t('season-selection.spring-summer')
    : t('season-selection.autumn-winter')

  return (
    <li key={season.season}>
      <button
        type="button"
        className="season-selection-page__season-button"
        data-testid={`season-page_season-button_${season.season.replace(/\s+/g, '')}`}
        aria-label={t('season-selection.season-button-aria-label', {
          type: typeLabel,
          year: fullYear,
        })}
        onClick={onClick}
      >
        <span className="season-selection-page__season-type">{typeLabel}</span>
        <strong className="season-selection-page__season-year">{fullYear}</strong>
      </button>
    </li>
  )
};
